import React, { useState } from 'react';
import { Input as AntdInput } from 'antd';
import { useTextField } from 'src/hooks/use-text-field';
import styles from './styles.module.less';
import { InputWrap } from '../input-wrap';

export function TextInput({ icon, ...props }) {
  const [focused, setFocus] = useState(false);
  const { name } = props;

  const [
    value,
    {
      hasError,
      handleOnChange,
      handleBlur,
      error,
    },
  ] = useTextField(name);

  const handleFocus = () => {
    setFocus(true);
  };

  const onBlur = (event) => {
    handleBlur(event);
    setFocus(false);
  };

  return (
    <InputWrap
      name={name}
      hasError={hasError}
      error={error}
      className={styles.root}
      focused={focused}
      icon={icon}
    >
      <AntdInput.TextArea
        {...props}
        bordered={false}
        value={value}
        onFocus={handleFocus}
        onChange={handleOnChange}
        onBlur={onBlur}
      />
    </InputWrap>
  );
}
